<template>
  <div class="card">
    <div
      class="text-sm flex flex-col gap-0.5 bg-white border border-dark-secondary rounded-md p-3 
      shadow-2xs dark:bg-background-alt dark:border-dark-border dark:text-text-primary-dark text-text-primary"
    >
      <p class="font-bold">Saldos del cliente</p>

      <p class="flex justify-between">
        Saldo Disponible: <b>{{ formatPrice(data.amountInAccount, '$', decimals) }}</b>
      </p>

      <p class="flex justify-between">
        Saldo en Tránsito:
        <b
          :style="{
            color: props.data.transactionType?.description === 'Abono' ? '#34a649' : '#be1b20',
          }"
        >
          {{ formatPrice(data.amount, '$', decimals) }}
        </b>
      </p>

      <!-- Saldo contable: rojo si es negativo, verde si es positivo -->
      <p class="flex justify-between ">
        Saldo Contable:
        <b
          :style="{
            color: rawTotalAmount() > 0 ? '#34a649' : '#be1b20',
          }"
        >
          {{ TotalAmount(decimals) }}
        </b>
      </p>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
const emit = defineEmits(['changeAmount'])
import { useCurrencyFormatter } from '../../composables/useFormatPrice'

const { formatPrice } = useCurrencyFormatter()

const decimals = computed(() => {
  return props.data.currencyType?.description === 'CLP' ? 0 : 2
})

// Función para obtener el monto numérico crudo (sin formato)
function rawTotalAmount() {
  if (props.data.transactionType?.description === 'Abono') {
    return props.data.amountInAccount + props.data.amount
  } else {
    const total = props.data.amountInAccount - props.data.amount
    const isNegative = total >= 0
    emit('changeAmount', isNegative)
    return total
  }
}

// Función que retorna el total formateado como string para mostrar
function TotalAmount(type) {
  return formatPrice(rawTotalAmount(), '$', type)
}
</script>
